import EntryComponent from './subComponents/entry/entry-component'
import Prelude1Component from './subComponents/prelude1/prelude1-component'
import Prelude2Component from './subComponents/prelude2/prelude2-component'
import Prelude3Component from './subComponents/prelude3/prelude3-component'
import FirstComponent from './subComponents/first/first-component'
import SecondComponent from './subComponents/second/second-component'
import ThirdComponent from './subComponents/third/third-component'
import FourthComponent from './subComponents/fourth/fourth-component'
import FifthComponent from './subComponents/fifth/fifth-component'
import SixthComponent from './subComponents/sixth/sixth-component'
import SeventhComponent from './subComponents/seventh/seventh-component'
import EighthComponent from './subComponents/eighth/eighth-component'
import NinethComponent from './subComponents/nineth/nineth-component'
import TenthComponent from './subComponents/tenth/tenth-component'
import EndComponent from './subComponents/end/end-component'

export default {
  name: 'plan',
  data: function() {
    return {
      errorMessage: false,
      currentQuestionNumber: 1,
      email: {
        'send_via_email': false,
        'email_address': ''
      },
      answers: {
        'water_heating': {
          'flow_heater': false,
          'central_heating': false,
          'boiler_w_pressure_comp': false,
          'boiler_no_pressure_comp': false,
          'none': false
        },
        'pressure_influencing': {
          'reflux_valve': false,
          'pressure_reducers': false,
          'water_filters': false,
          'water_softeners': false,
          'other_pressure_devices': false,
          'none': false
        },
        'cyclic': {
          'american_fridges_permanent_ice_makers': false,
          'aquariums_with_permanent_water_flow': false,
          'permanent_garden_drop_sprinklers': false,
          'house_humidifiers': false,
          'other_devices_w_cyclic_or_permanent_flow': false,
          'none': false
        },
        'high_consuming': {
          'swimming_pools': false,
          'time_based_garden_sprinklers': false,
          'showers_w_high_water_consumption': false,
          'other_devices_w_high_water_consumption': false,
          'none': false
        },
        'emergency_water': {
          'fire_sprinkler_system': false,
          'other_safety_devices': false,
          'none': false
        },
        'toilets': {
          'hasToilets': false
        },
        'installed_appliances': {
          'shower': 0,
          'bath_tub': 0,
          'toilets': 0,
          'dish_washer': false,
          'washing_machine': false
        },
        'water_management': {
          'water_cost': 0,
          'energy_cost': 0,
          'measure_unit': '',
          'heating_type': ''
        },
        'people': {
          'number': 0
        },
        'water_damage': {
          'yes': false,
          'no': false,
          'unknown': false
        },
        'pipe_system_type': {
          'copper': false,
          'plastic': false,
          'composite': false,
          'dont_know': false,
          'none_of_above': false
        },
        'pipe_system_replace': {
          'year': null
        },
        'house_size': {
          'house_size_number': 0,
          'measurement_unit': ''
        },
        'house_year': {
          'year': 0
        },
        'installer': {
          'name': '',
          'email': '',
          'phone': '',
          'streetNr': '',
          'pcCity': '',
          'country': ''
        },
        'self_installed': false
      },
      installGuideID: null,
      dl_link: null
    }
  },
  computed: {
    currentComponent: function() {
      return this.$store.getters.currentComponent
    },
    isBlue: function() {
      return this.$store.getters.isBlue
    },
    landingText: function() {
      return this.$store.getters.langFile[this.$options.name]
    },
    breadCrumbs: function() {
      return this.$store.getters.langFile['overview']
    },
    legal: function() {
      return this.$store.getters.langFile.legal
    }
  },
  components: {
    'entry-component': EntryComponent,
    'prelude1-component': Prelude1Component,
    'prelude2-component': Prelude2Component,
    'prelude3-component': Prelude3Component,
    'first-component': FirstComponent,
    'second-component': SecondComponent,
    'third-component': ThirdComponent,
    'fourth-component': FourthComponent,
    'fifth-component': FifthComponent,
    'sixth-component': SixthComponent,
    'seventh-component': SeventhComponent,
    'eighth-component': EighthComponent,
    'nineth-component': NinethComponent,
    'tenth-component': TenthComponent,
    'end-component': EndComponent
  },
  watch: {
    currentComponent: function() {
      if (this.currentComponent === 'entry-component' || this.currentComponent === 'end-component') {
        this.$store.commit('changeColor', true)
      } else {
        this.$store.commit('changeColor', false)
      }
    }
  },
  methods: {
    postQuestionnaire: function() {
      this.errorMessage = false
      let data = {
        'questionnaire': this.answers,
        'email': this.email,
        'language': this.$route.params.id
      }
      console.log(this.answers)
      // get data from api
      this.$http.post('questionnaire', data)
        .then(response => {
          if (response && response.body && response.body.installation_id) {
            console.log('/questionnaire', response.body)
            this.installGuideID = response.body.installation_id
            this.dl_link = response.body.dl_link
          }
        })
        // error callback
        .catch(err => {
          this.errorMessage = true
          console.log('Error:', err)
        })
    },

    changeComponent: function(newComponent, object) {
      this.$store.commit('changeName', newComponent)
      window.scrollTo(0, 0)

      switch (newComponent) {
        case 'prelude1-component':
          this.currentQuestionNumber = 1
          break
        case 'prelude2-component':
          this.currentQuestionNumber = 2
          break
        case 'prelude3-component':
          this.currentQuestionNumber = 3
          break
        case 'first-component':
          this.currentQuestionNumber = 4
          break
        case 'second-component':
          this.currentQuestionNumber = 5
          this.answers.water_heating = object
          break
        case 'third-component':
          this.currentQuestionNumber = 6
          this.answers.pressure_influencing = object
          break
        case 'fourth-component':
          this.currentQuestionNumber = 7
          this.answers.cyclic = object
          break
        case 'fifth-component':
          this.currentQuestionNumber = 8
          this.answers.high_consuming = object
          break
        case 'sixth-component':
          this.currentQuestionNumber = 9
          this.answers.emergency_water = object
          break
        case 'seventh-component':
          this.currentQuestionNumber = 10
          this.answers.toilets = object
          break
        case 'eighth-component':
          this.currentQuestionNumber = 11
          this.answers.people.number = object.people.number
          this.answers.water_damage.yes = object.water_damage.yes
          this.answers.water_damage.no = object.water_damage.no
          this.answers.water_damage.unknown = object.water_damage.unknown
          this.answers.house_size.house_size_number = object.house_size.house_size_number
          this.answers.house_size.measurement_unit = object.house_size.measurement_unit
          this.answers.house_year = object.house_year
          this.answers.pipe_system_type = object.pipe_system_type
          this.answers.pipe_system_replace = object.pipe_system_replace
          break
        case 'nineth-component':
          this.currentQuestionNumber = 12
          this.answers.installed_appliances = object
          break
        case 'tenth-component':
          this.currentQuestionNumber = 13
          this.answers.water_management = object
          break
      }
    },
    goToEnd: function(installer, email, self) {
      this.$store.commit('changeName', 'end-component')
      window.scrollTo(0, 0)

      this.currentQuestionNumber = 12
      this.answers.installer = installer
      this.email = email
      this.answers.self_installed = self
      this.postQuestionnaire()
    },
    goBack: function() {
      switch (this.currentComponent) {
        case 'prelude1-component':
          this.$store.commit('changeName', 'entry-component')
          this.currentQuestionNumber = 1
          break
        case 'prelude2-component':
          this.$store.commit('changeName', 'prelude1-component')
          this.currentQuestionNumber = 1
          break
        case 'prelude3-component':
          this.$store.commit('changeName', 'prelude2-component')
          this.currentQuestionNumber = 2
          break
        case 'first-component':
          this.$store.commit('changeName', 'prelude3-component')
          this.currentQuestionNumber = 3
          break
        case 'second-component':
          this.$store.commit('changeName', 'first-component')
          this.currentQuestionNumber = 4
          break
        case 'third-component':
          this.$store.commit('changeName', 'second-component')
          this.currentQuestionNumber = 5
          break
        case 'fourth-component':
          this.$store.commit('changeName', 'third-component')
          this.currentQuestionNumber = 6
          break
        case 'fifth-component':
          this.$store.commit('changeName', 'fourth-component')
          this.currentQuestionNumber = 7
          break
        case 'sixth-component':
          this.$store.commit('changeName', 'fifth-component')
          this.currentQuestionNumber = 8
          break
        case 'seventh-component':
          this.$store.commit('changeName', 'sixth-component')
          this.currentQuestionNumber = 9
          break
        case 'eighth-component':
          this.$store.commit('changeName', 'seventh-component')
          this.currentQuestionNumber = 10
          break
        case 'nineth-component':
          this.$store.commit('changeName', 'eighth-component')
          this.currentQuestionNumber = 11
          break
        case 'tenth-component':
          this.$store.commit('changeName', 'nineth-component')
          this.currentQuestionNumber = 12
          break
      }
    },
    cancelDesktop: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'overview',
        params: {
          id
        }
      })
    },
    goToImprint: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'imprint',
        params: {
          id
        }
      })
    },
    cancelMobile: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'landing',
        params: {
          id
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/plan/plan.js